import { ModelBase } from '../../core/model/model-base';
import { ErrandType } from '../../round-planning/model/const/enums';

export class ErrandTag extends ModelBase {
  constructor(data?: Partial<ErrandTag>) {
    super();
    Object.assign(this, data ?? {});
    this.locationAccessGroupIds = [...(data?.locationAccessGroupIds ?? [])];
  }

  name = '';
  isEnabled = true;
  accessGroupCount = 0;
  canDelete = true;
  locationAccessGroupIds: string[] = [];

  toSavePayload(): ErrandTagSavePayload {
    return {
      id: this.id,
      name: this.name?.trim(),
      isEnabled: this.isEnabled,
      locationAccessGroupIds: [...this.locationAccessGroupIds],
    };
  }

  override toString(): string {
    return this.name;
  }
}

export interface ErrandTagSavePayload {
  id?: string;
  name: string;
  isEnabled: boolean;
  locationAccessGroupIds: string[];
}

export interface ErrandTagSelection {
  id: string;
  name: string;
  isEnabled: boolean;
}

export interface ErrandTagAccessGroupSelection {
  id: string;
  name: string;
}

export interface ErrandAssignmentOption {
  id: string;
  name: string;
  executorGroupIds?: string[];
}

export interface PropertyErrandTagResponsibility {
  id?: string;
  errandTagId: string;
  errandTagName?: string;
  resourceId?: string;
  resourceName?: string;
  executorGroupId?: string;
  executorGroupName?: string;
  executorWebUserId?: string;
  executorWebUserName?: string;
}

export interface ErrandAssignmentOptions {
  errandType: ErrandType;
  propertyId: string;
  errandTagId?: string;
  resources: ErrandAssignmentOption[];
  executorGroups: ErrandAssignmentOption[];
  executorWebUsers: ErrandAssignmentOption[];
  executorWebUserPool?: ErrandAssignmentOption[];
  configuredResponsibility?: PropertyErrandTagResponsibility;
}
